import { ReactAppParams } from '../types/ReactAppParams';

/**
 * Načtení konfigu aplikace.
 */
export function useAppConfig(): ReactAppParams {
  return (
    window?.appConfig || {
      applicationId: -1,
      applicationName: 'NONE',
      applicationCode: 'NONE',
      isInMC: true,
      version: 'NONE',
      testEnvironment: true,
      serverContextPath: '',
      bootVersion: '',
      sharedVersion: '',
      maxFileSize: 200 * 1024 * 1024,
    }
  );
}
